export type ResolvedDraftStatus = 'sent' | 'discarded';

/** Mirror a resolved draft on its bubble: new state, plus the text and file that went out, if known. */
export function applyDraftToMessages(
  messages: any[],
  messageId: string,
  status: ResolvedDraftStatus,
  text?: string,
  media?: Record<string, unknown>,
): any[] {
  return messages.map((message) => (message.id === messageId
    ? {
      ...message,
      ...(text !== undefined ? { text } : {}),
      metadata: { ...message.metadata, ...media, draft: { ...message.metadata?.draft, status } },
    }
    : message));
}

/** Same on the conversation list, whose chip reads the last message's draft status. */
export function applyDraftToChats(chats: any[], chatId: string | undefined, status: ResolvedDraftStatus) {
  return chats.map((chat) => (chat.id === chatId && chat.last_message_metadata?.draft
    ? {
      ...chat,
      last_message_metadata: {
        ...chat.last_message_metadata,
        draft: { ...chat.last_message_metadata.draft, status },
      },
    }
    : chat));
}

/** Mirror a saved (still pending) edit on its card: new text, html and file. */
export function applyDraftEditToMessages(
  messages: any[],
  messageId: string,
  edit: { text?: string; html?: string | null; attachment?: unknown },
): any[] {
  return messages.map((message) => (message.id === messageId
    ? {
      ...message,
      ...(edit.text !== undefined ? { text: edit.text } : {}),
      metadata: {
        ...message.metadata,
        draft: {
          ...message.metadata?.draft,
          html: edit.html ?? null,
          attachment: edit.attachment ?? null,
        },
      },
    }
    : message));
}
